// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "dirty": false,
    "raw": "709fa094",
    "hash": "709fa094",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "709fa094",
    "semverString": null,
    "version": "0.0.0"
};
/* tslint:enable */
